import { Phone } from '../api-client';
import formatPhone from './formatPhone';

const hidePhone = (phone: Phone): string => {
  const formattedPhone = formatPhone(phone);
  return formattedPhone.replace(/\d{3}-\d{2}/g, 'XXX-XX');
};

export default hidePhone;
